import {
  Utensils, Beer, Wine, Scissors, Sparkles, Coffee, Truck, Car, Pizza,
  IceCream, Croissant, Home, Wrench, Fish, PawPrint, ShoppingCart,
  Cake, Store, Dumbbell, Stethoscope, Shirt, Baby, Hammer, Flower2,
  Gem, Gift, Cake as CakeIcon, Cross, Bike, Bus, Camera, Music,
  Laptop, Smartphone, Wifi, Book, Palette, Hotel, Plane, Leaf,
  Heart, Star, Briefcase, Key, Shield, Droplet, Flame, Sun,
} from "lucide-react";

// Curated icon registry the admin can choose from when creating categories.
export const ICON_REGISTRY = {
  Utensils, Beer, Wine, Scissors, Sparkles, Coffee, Truck, Car, Pizza,
  IceCream, Croissant, Home, Wrench, Fish, PawPrint, ShoppingCart,
  Cake, Store, Dumbbell, Stethoscope, Shirt, Baby, Hammer, Flower2,
  Gem, Gift, Cross, Bike, Bus, Camera, Music, Laptop, Smartphone,
  Wifi, Book, Palette, Hotel, Plane, Leaf, Heart, Star, Briefcase,
  Key, Shield, Droplet, Flame, Sun,
};

export const ICON_NAMES = Object.keys(ICON_REGISTRY);

export function getIcon(name) {
  return ICON_REGISTRY[name] || Store;
}
